export const WISHLIST_UPDATE_EVENT = 'omneo:wishlist:update'

/**
 * hooks/useWishlist.js applies `wishlistActions` optimistically before refetching,
 * so always send the detailed form. A bare Event forces every listener to refetch.
 */
export const dispatchWishlistUpdate = (wishlistActions = []) => {
  document.dispatchEvent(
    new CustomEvent(WISHLIST_UPDATE_EVENT, { detail: { useCache: false, wishlistActions } })
  )
}

export const toWishlistActions = (appliedOperations, lists) =>
  appliedOperations
    .filter((op) => op.ok && op.type !== 'update')
    .map((op) => ({
      action: op.type === 'add' ? 'add' : 'remove',
      list: lists.find((l) => String(l.id) === String(op.listId)),
      item: op.item ?? { id: op.itemId }
    }))
    .filter((action) => action.list)
